import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Customer Service' },
	{
		name: 'description',
		content:
			'We are seeking capable, caring individuals to join our customer service department.',
	},
]

const CareersPage = () => (
	<main className="mx-auto my-10 max-w-7xl">
		<Link to="/" prefetch="intent" className="text-blue-600 underline">
			Home
		</Link>{' '}
		&rarr;{' '}
		<Link to="/careers/" prefetch="intent" className="text-blue-600 underline">
			Careers
		</Link>
		<br />
		<br />
		<h1 className="py-3 text-4xl font-black">
			Customer Service Representative (CSR)
		</h1>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			<h3>Job Description</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				We are seeking capable, caring individuals to join our customer service
				department. As an independent insurance professional you will work on a
				team that shares your desire to make a difference by helping people.
			</p>
			<h3>Job Responsibilities</h3>
			<ul>
				<li>Maintain knowledge of insurance products</li>
				<li>Assist clients with their day-to-day insurance needs</li>
				<li>Be outstanding at relationship building</li>
				<li>
					Present and explain insurance policy options based upon client needs
				</li>
			</ul>
			<h3>Job Requirements</h3>
			<ul>
				<li>Exhibit professional phone and interpersonal etiquette</li>
				<li>
					Possess, or be able to obtain, a property & casualty insurance license
				</li>
				<li>Display highly capable problem-solving skills</li>
				<li>Possess a strong work ethic</li>
				<li>Work with a positive attitude</li>
				<li>
					Demonstrate strong communication and empathetic listening skills
				</li>
			</ul>
			<br />
			Send an email with your resume and cover letter to{' '}
			<a
				href="mailto:careers@steeleagency.com"
				className="text-indigo-500 underline"
			>
				careers@steeleagency.com
			</a>{' '}
			to start the application process.
		</p>
	</main>
)

export default CareersPage
